// Pricing helpers shared by cart, checkout, and product views.

const toNumber = (v) => {
    const n = typeof v === 'number' ? v : parseFloat(v);
    return Number.isFinite(n) ? n : 0;
};

export const getSalePercent = (product) => {
    if (!product?.sale?.enabled) return 0;
    const raw = parseInt(product.sale.percent, 10);
    if (!Number.isFinite(raw)) return 0;
    return Math.max(0, Math.min(100, raw));
};

// Base unit price after sale discount (paid options not included).
export const getEffectiveUnitPrice = (product) => {
    const base = toNumber(product?.price);
    const percent = getSalePercent(product);
    if (percent <= 0) return base;
    return Math.round(base * (100 - percent)) / 100;
};

// Sum of selected paid options' prices (per unit; not multiplied by quantity).
export const getPaidOptionsTotalPerUnit = (item) =>
    (item?.selectedPaidOptions || []).reduce((sum, opt) => sum + toNumber(opt?.price), 0);
